module.exports = __webpack_public_path__ + "static/media/gallery6.7563df77.jpg";